import React from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Text from '../Text';
import SectionHeader from '../SectionHeader';
import ScrollReveal from '../animated/ScrollReveal';
import MagneticButton from '../animated/MagneticButton';
import { colors, gradients } from '../../theme/designTokens';
import { technologyFeatures } from '../../data/insights';

const TechnologyTeaser = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        px: { xs: 2, sm: 3, md: 4 },
        py: { xs: 8, md: 12 },
        background: gradients.sectionDark,
      }}
    >
      <Box sx={{ maxWidth: 1100, mx: 'auto' }}>
        <ScrollReveal>
          <SectionHeader
            eyebrow="Technology"
            title="Technology Enabled Resilience."
            highlightWords={['Technology']}
            subtitle="AI, analytics, monitoring, and proprietary platforms that make resilience measurable and actionable."
            light
          />
        </ScrollReveal>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: 'repeat(3, 1fr)' },
            gap: 2,
          }}
        >
          {technologyFeatures.map((feat) => {
            const isExternal = Boolean(feat.href && feat.href.startsWith('http'));
            return (
            <Box
              key={feat.title}
              component={feat.href ? 'a' : 'div'}
              href={feat.href}
              target={isExternal ? '_blank' : undefined}
              rel={isExternal ? 'noopener noreferrer' : undefined}
              sx={{
                p: 3,
                border: `1px solid ${colors.glassBorder}`,
                background: 'rgba(255,255,255,0.03)',
                textDecoration: 'none',
                color: 'inherit',
                display: 'block',
                cursor: feat.href ? 'pointer' : 'default',
                transition: 'border-color 0.25s ease, background 0.25s ease',
                ...(feat.href
                  ? {
                      '&:hover': {
                        borderColor: 'rgba(212,160,23,0.45)',
                        background: 'rgba(212,160,23,0.06)',
                      },
                    }
                  : {}),
              }}
            >
              <Text variant="h4" color="white" sx={{ mb: 1 }}>
                {feat.title}
              </Text>
              <Text variant="bodySm" color="muted">
                {feat.description}
              </Text>
            </Box>
            );
          })}
        </Box>

        <Box sx={{ textAlign: 'center', mt: 5 }}>
          <MagneticButton onClick={() => navigate('/technology')}>
            Explore Technology
          </MagneticButton>
        </Box>
      </Box>
    </Box>
  );
};

export default TechnologyTeaser;
